import {
  Box,
  Container,
  Stack,
  SimpleGrid,
  Text,
  Link,
  useColorModeValue,
  IconButton
} from '@chakra-ui/react'
import { Link as RouterLink } from 'react-router-dom'
import { YoutubeLogo, XLogo } from '@phosphor-icons/react' // Import icons

export default function Footer() {
  // Use semantic tokens for background, text, and borders
  return (
    <Box
      bg="bg.default" // Use theme's default background
      color="text.default" // Use theme's default text color
      borderTop={1}
      borderStyle={'solid'}
      borderColor="border.default" // Use theme's default border color
    >
      <Container as={Stack} maxW={'container.xl'} py={10}>
        <SimpleGrid
          templateColumns={{ sm: '1fr 1fr', md: '2fr 1fr 1fr 1fr' }}
          spacing={8}
        >
          <Stack spacing={6}>
            <Box>
              <Text fontSize={{ base: 'lg', md: 'xl' }} fontWeight="bold"> {/* Responsive font */}
                Megalith Maps
              </Text>
            </Box>
            <Text fontSize={{ base: 'xs', md: 'sm' }}> {/* Responsive font */}
              Discover ancient sites around the world. Explore megalithic structures and their history.
            </Text>
          </Stack>
          <Stack align={'flex-start'}>
            <Text fontWeight={'500'} fontSize={{ base: 'md', md: 'lg' }} mb={2}> {/* Responsive font */}
              Company
            </Text>
            <Link as={RouterLink} to="/about">About Us</Link>
            <Link as={RouterLink} to="/contact">Contact</Link>
            <Link as={RouterLink} to="/terms">Terms of Service</Link>
            <Link as={RouterLink} to="/privacy">Privacy Policy</Link>
          </Stack>
          <Stack align={'flex-start'}>
            <Text fontWeight={'500'} fontSize={{ base: 'md', md: 'lg' }} mb={2}> {/* Responsive font */}
              Community
            </Text>
            <Link as={RouterLink} to="/register">Register</Link>
            <Link as={RouterLink} to="/login">Sign In</Link>
            <Link as={RouterLink} to="/dashboard">Dashboard</Link>
          </Stack>
          <Stack align={'flex-start'}>
            <Text fontWeight={'500'} fontSize={{ base: 'md', md: 'lg' }} mb={2}> {/* Responsive font */}
              Explore
            </Text>
            <Link as={RouterLink} to="/search">Find a Site</Link>
            <Link as={RouterLink} to="/about#how-it-works">How It Works</Link>
            <Link as={RouterLink} to="/map">Map</Link>
          </Stack>
          <Stack align={'flex-start'}>
            <Text fontWeight={'500'} fontSize={{ base: 'md', md: 'lg' }} mb={2}>
              Legal
            </Text>
            <Link as={RouterLink} to="/dmca">DMCA Takedown</Link>
            <Link as={RouterLink} to="/request-credit">Request Credit</Link>
            <Link as={RouterLink} to="/copyright">Copyright Policy</Link>
          </Stack>
        </SimpleGrid>
      </Container>
      
      
      <Box
        borderTopWidth={1}
        borderStyle={'solid'}
        borderColor="border.default" // Use theme's default border color
      >
        <Container
          as={Stack}
          maxW={'container.xl'}
          py={4}
          direction={{ base: 'column', md: 'row' }}
          spacing={4}
          justify={{ base: 'center', md: 'space-between' }}
          align={{ base: 'center', md: 'center' }}
        >
          <Text fontSize={{ base: 'xs', md: 'sm' }}>© {new Date().getFullYear()} Megalith Maps. All rights reserved</Text> {/* Responsive font */}
          <Stack direction={'row'} spacing={4}> {/* Adjusted spacing */}
            <IconButton
              as="a"
              href="https://x.com/Ex_Excursion"
              target="_blank" 
              rel="noopener noreferrer"
              aria-label="X (formerly Twitter)"
              icon={<XLogo size={20} />}
              variant="ghost"
              color="text.subtle" // Use subtle text color
              _hover={{ bg: 'bg.subtle' }} // Use subtle background on hover
            />
            <IconButton
              as="a"
              href="https://youtube.com/@existentialexcursion?feature=shared"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="YouTube"
              icon={<YoutubeLogo size={20} />}
              variant="ghost"
              color="text.subtle" // Use subtle text color
              _hover={{ bg: 'bg.subtle' }} // Use subtle background on hover
            />
          </Stack>
        </Container>
      </Box>
    </Box>
  )
}
